import { NgModule } from "@angular/core";
import {
  Routes,
  RouterModule,
  PreloadingStrategy,
  Route,
  PreloadAllModules,
} from "@angular/router";
import { LoginComponent } from "./views/login/login.component";
import { ForgetPasswordComponent } from "./views/forgetPassword/forgetPassword.component";
import { companyPolicyComponent } from "./views/cookies/companyPolicy";
import { privacyPolicyComponent } from "./views/cookies/privacyPolicy";
import { AlarmlegendsComponent } from "./views/alarmlegends/alarmlegends.component";
import { UpdatePasswordComponent } from "./views/update-password/update-password.component";
import { AuthGuard } from "./service/AuthGuard/authGuard";
import { DefaultLayoutComponent } from "./containers/default-layout/default-layout.component";
import { ExternalRedirectGuard } from "./service/AuthGuard/ExternalRedirectGuard";

// export class CustomPreloadingStrategy implements PreloadingStrategy {
//   preload(route: Route, load: () => Observable<any>): Observable<any> {
//     return route.data && route.data["preload"] ? load() : of(null);
//   }
// }
export const routes: Routes = [
  {
    path: "updatePassword",
    component: UpdatePasswordComponent,
    data: {
      title: "Update Password",
    },
  },
  {
    path: "forgetPassword",
    component: ForgetPasswordComponent,
    data: {
      title: "Forget Password",
    },
  },

  {
    path: "login",
    component: LoginComponent,
    data: {
      title: "Login Page",
    },
  },
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },
  {
    path: "",
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      title: "",
    },

    children: [
      {
        path: "101",
        loadChildren: () =>
          import("./views/dashboard/dashboard.module").then(
            (m) => m.DashboardModule,
          ),
      },
      {
        path: "106",
        loadChildren: () =>
          import("./views/alarms/alarms.module").then((m) => m.AlarmsModule),
      },
      {
        path: "alarmHistory",
        loadChildren: () =>
          import("./views/alarmHistory/alarmHistory.module").then(
            (m) => m.AlarmHistoryModule,
          ),
      },
      {
        path: "104",
        loadChildren: () =>
          import("./views/siteListing/siteListing.module").then(
            (m) => m.SiteListingModule,
          ),
      },
      // {
      //   path: "siteDetails",
      //   loadChildren: () =>
      //     import("./views/siteDetails/siteDetails.module").then(
      //       (m) => m.SiteDetailsModule
      //     ),
      //   data: { preload: true },
      // },
      {
        path: "siteDetails",
        loadChildren: () =>
          import("./views/siteDetails/siteDetails.module").then(
            (m) => m.SiteDetailsModule,
          ),
      },
      {
        path: "energydash",
        loadChildren: () =>
          import("./views/energy-dash/energy-dash.module").then(
            (m) => m.EnergyDashModule
          ),
      },

      {
        path: "tenantDashboard",
        loadChildren: () =>
          import("./views/siteTenants/siteTenants.module").then(
            (m) => m.SiteDetailsModule,
          ),
      },
      {
        path: "equipments",
        loadChildren: () =>
          import("./views/equipments/equipments.module").then(
            (m) => m.EquipmentsModule,
          ),
      },
      {
        path: "userSetting",
        loadChildren: () =>
          import("./views/userSetting/userSetting.module").then(
            (m) => m.UserSettingModule,
          ),
      },

      {
        path: "110",
        loadChildren: () =>
          import("./views/custom-report/custom-report.module").then(
            (m) => m.CustomReportModule,
          ),
      },
      {
        path: "RP0101",
        loadChildren: () =>
          import("./views/newReports/reports.module").then(
            (m) => m.ReportModule,
          ),
      },
      {
        path: "RP0105",
        loadChildren: () =>
          import("./views/newReports/reports.module").then(
            (m) => m.ReportModule
          ),
      },
      {
        path: "RP0102",
        loadChildren: () =>
          import("./views/newReports/reports.module").then(
            (m) => m.ReportModule,
          ),
      },
      {
        path: "RP0103",
        loadChildren: () =>
          import("./views/newReports/reports.module").then(
            (m) => m.ReportModule,
          ),
      },

      {
        path: "getControllerMdl",
        loadChildren: () =>
          import("./views/getModules/getControllerMdl.module").then(
            (m) => m.GetContrllerMdlModule,
          ),
      },
      {
        path: "114",
        loadChildren: () =>
          import("./views/outgoingCommand/outgoingCmd.module").then(
            (m) => m.OutgoingCmdModule,
          ),
      },
      {
        path: "117",
        loadChildren: () =>
          import("./views/equipmentCommand/equipmentCmd.module").then(
            (m) => m.EquipmentCmdModule,
          ),
      },
      {
        path: "isenseConfig",
        loadChildren: () =>
          import("./views/isenseConfig/isenseConfig.module").then(
            (m) => m.IsenseConfigModule,
          ),
      },
      {
        path: "112",
        loadChildren: () =>
          import("./views/siteMaps/siteMaps.module").then(
            (m) => m.SiteMapsModule,
          ),
      },

      {
        path: "102",
        loadChildren: () =>
          import("./views/summaryDashboard/summaryDashboard.module").then(
            (m) => m.SummaryDashboardModule,
          ),
      },

      {
        path: "siteAccessHistory",
        loadChildren: () =>
          import("./views/siteacesslog/siteAccessHistory.module").then(
            (m) => m.SiteAccessHistoryModule,
          ),
      },

      {
        path: "539",
        loadChildren: () =>
          import("./views/alarmConfig/alarmConfig.module").then(
            (m) => m.AlarmConfigModule,
          ),
      },
      {
        path: "115",
        loadChildren: () =>
          import("./views/modbusTerminal/modbusTerminal.module").then(
            (m) => m.modbusTerminalModule,
          ),
      },
      {
        path: "modbusTerminalHistory",
        loadChildren: () =>
          import("./views/modbusTerminalHistory/modbusTerminalHistory.module").then(
            (m) => m.modbusTerminalHistoryModule,
          ),
      },
      {
        path: "repDashboard",
        loadChildren: () =>
          import("./views/reportDashboard/reportDashboard.module").then(
            (m) => m.ReportDashboardModule,
          ),
      },
      {
        path: "116",
        component: AlarmlegendsComponent,
        data: {
          title: "Alarm Legends",
        },
      },
      {
        path: "newgraphicaldashboard",
        loadChildren: () =>
          import("./views/newgraphicaldashboard/newgraphicaldashboard.module").then(
            (m) => m.newgraphicaldashboardModule,
          ),
      },
      {
        path: "105",
        loadChildren: () =>
          import("./views/monitoringdashboard/monitoringdashboard.module").then(
            (m) => m.monitoringDashboardModule,
          ),
      },
      {
        path: "122",
        loadChildren: () =>
          import("./views/monitoringdashboard/monitoringdashboard.module").then(
            (m) => m.monitoringDashboardModule,
          ),
      },
      {
        path: "140",
        loadChildren: () =>
          import("./views/monitoringdashboard/monitoringdashboard.module").then(
            (m) => m.monitoringDashboardModule,
          ),
      },
      {
        path: "141",
        loadChildren: () =>
          import("./views/ems-Gen-Dahboard/ems-Gen-Dahboard.module").then(
            (m) => m.EmsGenDahboardModule,
          ),
      },
      {
        path: "121",
        loadChildren: () =>
          import("./views/emsDashboard/dashboard.module").then(
            (m) => m.DashboardModule,
          ),
      },
      {
        path: "124",
        loadChildren: () =>
          import("./views/emsPayment-history/payment-history.module").then(
            (m) => m.PaymentHistoryModule,
          ),
      },
      {
        path: "123",
        loadChildren: () =>
          import("./views/calender-view/calender-view.module").then(
            (m) => m.CalenderViewModule,
          ),
      },
      {
        path: "125",
        loadChildren: () =>
          import("./views/ems-window/ems-window.module").then(
            (m) => m.EmsWindowModule,
          ),
      },
      {
        path: "126",
        loadChildren: () =>
          import("./views/emsTagView/emsTagView.module").then(
            (m) => m.EmsTagViewModule,
          ),
      },
      {
        path: "vending",
        loadChildren: () =>
          import("./views/emsVending/vending.module").then(
            (m) => m.VendingModule,
          ),
      },
      {
        path: "127",
        loadChildren: () =>
          import("./views/ems-lcdsreen/ems-lcdsreen.module").then(
            (m) => m.EmsLcdsreenModule,
          ),
      },
      {
        path: "129",
        loadChildren: () =>
          import("./views/ems_customerdashboard/ems_customerdashboard.module").then(
            (m) => m.Ems_customerdashboardModule,
          ),
      },
      {
        path: "130",
        loadChildren: () =>
          import("./views/ems-consumVsCost/consumptionVsCost.module").then(
            (m) => m.ConsumptionVsCostModule,
          ),
      },
      {
        path: "131",
        loadChildren: () =>
          import("./views/libDashboard/libDashboard.module").then(
            (m) => m.libDashboardModule,
          ),
      },
      //133 service Main 134 service maintaince
      {
        path: "135",
        loadChildren: () =>
          import("./views/maintenancescreen/maintenancescreen.module").then(
            (m) => m.MaintenancescreenModule,
          ),
      },
      {
        path: "999",
        loadChildren: () =>
          import("./views/maintenancescreen/maintenancescreen.module").then(
            (m) => m.MaintenancescreenModule,
          ),
      },
      {
        path: "136",
        loadChildren: () =>
          import("./views/TTlog-Creation/ttlog.module").then(
            (m) => m.ttlogModule,
          ),
      },
      {
        path: "137",
        loadChildren: () =>
          import("./views/time-diff-dashboard/dashboard-time-diff.module").then(
            (m) => m.DashboardTimeDiffModule,
          ),
      },
      {
        path: "154",
        loadChildren: () =>
          import("./views/piz_charts/piz_charts.module").then(
            (m) => m.Piz_chartsModule,
          ),
      },
      {
        path: "OptimizedCharts",
        loadChildren: () =>
          import("./views/OptimizedMultiCharts/OptimizedMultiCharts.module").then(
            (m) => m.OptimizedMultiChartsModule,
          ),
      },
      {
        path: "multiple charts",
        loadChildren: () =>
          import("./views/multiplecharts/multiplecharts.module").then(
            (m) => m.MultiplechartsModule,
          ),
      },
      {
        path: "139",
        loadChildren: () =>
          import("./views/commandAuditLog/cmdAuditLog.module").then(
            (m) => m.CmdAuditLogModule,
          ),
      },
      // {
      //   path: "139",
      //   canActivate: [ExternalRedirectGuard]
      // },
      {
        path: "156",
        canActivate: [ExternalRedirectGuard],
      },
      {
        path: "DB00103",
        canActivate: [ExternalRedirectGuard],
      },
      // {
      //   path: "156",
      //   loadChildren: () =>
      //     import("./views/analysisCharts/analysisCharts.module").then(
      //       (m) => m.AnalysisChartsModule
      //     ),
      // },
      {
        path: "138",
        loadChildren: () =>
          import("./views/application-Auditlog/application-Auditlog.module").then(
            (m) => m.ApplicationAuditlogModule,
          ),
      },
      {
        path: "cameraImages",
        loadChildren: () =>
          import("./views/cameraImages/cameraImages.module").then(
            (m) => m.CameraImagesModule,
          ),
      },
      {
        path: "device_dashboard",
        loadChildren: () =>
          import("./views/device_dashboard/device_dashboard.module").then(
            (m) => m.Device_dashboardModule,
          ),
      },
      {
        path: "142",
        loadChildren: () =>
          import("./views/new-CustomReport/new-CustomReport.module").then(
            (m) => m.NewCustomReportModule,
          ),
      },
      {
        path: "153",
        loadChildren: () =>
          import("./views/Device_overview/Device_overview.module").then(
            (m) => m.Device_overviewModule,
          ),
      },
      {
        path: "211",
        loadChildren: () =>
          import("./views/solar_Dashboard/solar_Dashboard.module").then(
            (m) => m.Solar_DashboardModule,
          ),
      },
      {
        path: "212",
        loadChildren: () =>
          import("./views/solar_dash_singlePhase/solar_SinglePhase_Dashboard.module").then(
            (m) => m.SolarSinglePhase_DashboardModule,
          ),
      },
      {
        path: "221",
        loadChildren: () =>
          import("./views/siteEnergyDashboard/siteEnergyDashboard.module").then(
            (m) => m.SiteEnergyDashboardModule,
          ),
      },
      {
        path: "222",
        loadChildren: () =>
          import("./views/fuelnotification-screen/fuelnotification-screen.module").then(
            (m) => m.FuelnotificationScreenModule,
          ),
      },
    ],
  },

  {
    path: "**",
    redirectTo: "login",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // preloadingStrategy: CustomPreloadingStrategy,
      // preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: "reload",
      // relativeLinkResolution: "legacy", // Uncomment if needed
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
